import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import PackageList from 'components/PackageList';
import Page from 'components/Page';
import TableSorting from 'components/TableSorting';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import EntityListPageSkeleton from 'components/OrderListPageSkeleton';

import { makeAfter, withData } from 'lib/relay';
import { makeFilter } from 'components/PackageList';

import { PackageListPageQuery } from '__generated__/PackageListPageQuery.graphql';

const query = graphql`
  query PackageListPageQuery(
    $first: Int!
    $after: String
    $search: String
    $sort: PackageSorting
    $filters: PackagesFilterInput
  ) {
    ...PackageList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<PackageListPageQuery>;
};

const breadcrumbs = [{ name: 'Pasiūlymai' }];

const PackageListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<PackageListPageQuery>(query, preloadedQuery);

  return (
    <Page breadcrumbs={breadcrumbs}>
      <TableSorting>
        <Pagination>
          <Search>
            <PackageList data={data} />
          </Search>
        </Pagination>
      </TableSorting>
    </Page>
  );
};

export default withData<PackageListPageQuery>({
  query,
  reloadOnRender: false,
  loading: <EntityListPageSkeleton breadcrumbs={breadcrumbs} cols={5} />,

  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    filters: makeFilter(searchParams),
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(PackageListPage);
